import { render, staticRenderFns } from "./HisroryNull.vue?vue&type=template&id=669e1f06&scoped=true&"
import script from "./HisroryNull.vue?vue&type=script&lang=ts&"
export * from "./HisroryNull.vue?vue&type=script&lang=ts&"
import style0 from "./HisroryNull.vue?vue&type=style&index=0&id=669e1f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e1f06",
  null
  
)

export default component.exports